module.exports = __webpack_public_path__ + "ba5ddcf1120ba391f26e52312dd55271.woff2";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Lato-Italic.woff2
// module id = 703
// module chunks = 0